import React, { createContext, useContext, useState, useCallback } from 'react';
import { getOrganization, getOrgMembers, getOrgStats, getOrgInvitations } from '../api/api';
import { useAuth } from './AuthContext';

const OrganizationContext = createContext(null);

export const OrganizationProvider = ({ children }) => {
  const { activeOrg } = useAuth();

  const [org, setOrg]                 = useState(null);
  const [members, setMembers]         = useState([]);
  const [invitations, setInvitations] = useState([]);
  const [stats, setStats]             = useState(null);
  const [loadingOrg, setLoadingOrg]   = useState(false);
  const [error, setError]             = useState(null);

  const fetchOrg = useCallback(async (orgId) => {
    const id = orgId || activeOrg?.id;
    if (!id) return;
    setLoadingOrg(true);
    setError(null);
    try {
      const res = await getOrganization(id);
      setOrg(res?.data?.data?.organization || res?.data?.data || null);
    } catch (e) {
      setError(e?.response?.data?.message || 'Failed to load organization');
    } finally {
      setLoadingOrg(false);
    }
  }, [activeOrg?.id]);

  const fetchMembers = useCallback(async (orgId, params = {}) => {
    const id = orgId || activeOrg?.id;
    if (!id) return;
    const res = await getOrgMembers(id, params);
    setMembers(res?.data?.data?.members || res?.data?.data || []);
  }, [activeOrg?.id]);

  const fetchStats = useCallback(async (orgId) => {
    const id = orgId || activeOrg?.id;
    if (!id) return;
    const res = await getOrgStats(id);
    setStats(res?.data?.data || null);
  }, [activeOrg?.id]);

  const fetchInvitations = useCallback(async (orgId) => {
    const id = orgId || activeOrg?.id;
    if (!id) return;
    const res = await getOrgInvitations(id);
    setInvitations(res?.data?.data?.invitations || res?.data?.data || []);
  }, [activeOrg?.id]);

  return (
    <OrganizationContext.Provider value={{
      org, members, invitations, stats,
      loadingOrg, error,
      fetchOrg, fetchMembers, fetchStats, fetchInvitations,
      setOrg, setMembers, setInvitations,
    }}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const useOrganization = () => useContext(OrganizationContext);
